/*
 * @Author: 秦少卫
 * @Date: 2024-06-09 13:04:51
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-09 17:27:04
 * @Description: 管理员API
 */

import axios from 'axios';
import { createInstance } from './strapiClass';
import router from '@/router';
const baseURL = import.meta.env.APP_ADMINAPIHOST;
const instance = axios.create({ baseURL });

// 添加请求拦截器动态更新baseURL
instance.interceptors.request.use((config) => {
  config.baseURL = getBaseURL();
  return config;
});
// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    try {
      const currentRoute = router.currentRoute.value;
      // 检查当前路由是否包含 /admin
      if (currentRoute.path.includes('/admin')) {
        if (error.response && error.response.status === 401) {
          // 跳转到登录页面
          router.push('/login');
        }
      }
    } catch (e) {
      console.error('获取路由实例失败:', e);
    }
    return Promise.reject(error);
  }
);

// 获取baseURL 优先使用localStorage
export function getBaseURL() {
  return localStorage.getItem('baseURL') || baseURL;
}

export function getFileURL(url: string) {
  if (url.startsWith('http')) {
    return url;
  }
  return localStorage.getItem('baseURL') || baseURL + url;
}

createInstance(instance, true, false, getToken);

const tokenKey = 'AdminToken';
export function getToken() {
  const token = localStorage.getItem(tokenKey);
  return token;
}

export function setToken(token: string) {
  localStorage.setItem(tokenKey, token);
}

// 管理员登录
export const adminLogin = (data: any) => instance.post('/admin/login', data);

// 登出
export const logout = () => localStorage.setItem(tokenKey, '');

// 管理员详情
export const getAdminInfo = (data?: any) => instance.get('/admin/users/me', data);

// 通用api
const createapi = (key: any) => {
  //获取
  const get = (params: any) =>
    instance.get(`/content-manager/collection-types/${key}`, {
      params,
    });
  // 新增
  const create = (data: any) => instance.post(`/content-manager/collection-types/${key}`, data);
  // 发布
  const publish = (id: string) =>
    instance.post(`/content-manager/collection-types/${key}/${id}/actions/publish`);
  //修改
  const update = (id: any, data: any) =>
    instance.put(`/content-manager/collection-types/${key}/${id}`, data);

  const getOptions = (optionsKey: any, params: any) =>
    instance.get(`/content-manager/relations/${key}/${optionsKey}`, {
      params,
    });

  const getOptionsValue = (optionsKey: any, id: any, params: any) =>
    instance.get(`/content-manager/relations/${key}/${id}/${optionsKey}`, {
      params,
    });

  const foxGet = (params: any) =>
    instance.get(`/admin-extension/custom-data/${key}`, {
      params,
    });

  return { get, create, publish, update, getOptions, getOptionsValue, foxGet };
};

//------------------异形商品管理的api-------------------

// 材质管理的api
export const materialApi = createapi('api::df-material.df-material');
//覆膜图素材管理
export const filmCoverApi = createapi('api::df-film-cover.df-film-cover');
//外配件素材管理
export const outsideApi = createapi('api::df-outside.df-outside');
//背景图管理
export const DfbgImgApi = createapi('api::df-bg-img.df-bg-img');
//尺寸管理
export const DfSizeApi = createapi('api::df-size.df-size');
//商品管理
export const DfCommodityApi = createapi('api::df-commodity.df-commodity');

// ------------------------------------------------------

//3D渲染模型管理的api
export const renderingMaterialApi = createapi(
  'api::rendering-material-management.rendering-material-management'
);
// 法线材质管理的获取
export const normalMaterialApi = createapi('api::normal-material.normal-material');
//充值管理的获取
export const getRechrage = (params: any) =>
  instance.get(`/content-manager/collection-types/api::payment.payment`, {
    params,
  });
// 充值管理的新增
export const createRechrage = (data: any) =>
  instance.post(`/content-manager/collection-types/api::payment.payment`, data);
// 充值管理的发布
export const publishRechrage = (id: string) =>
  instance.post(`/content-manager/collection-types/api::payment.payment/${id}/actions/publish`);
//充值管理的取消发布
export const unpublishRechrage = (id: string) =>
  instance.post(`/content-manager/collection-types/api::payment.payment/${id}/actions/unpublish`);
//充值管理的修改
export const updateRechrage = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::payment.payment/${id}`, data);
//充值管理的删除
export const deleteRechrage = (id: string) =>
  instance.delete(`content-manager/collection-types/api::payment.payment/${id}`);

//ai风格化提示词新增
export const createAiPrompt = (data: any) =>
  instance.post('/content-manager/collection-types/api::prompt-style.prompt-style', data);
//ai风格化提示词获取
export const getAiPrompt = (params: any) =>
  instance.get(`/content-manager/collection-types/api::prompt-style.prompt-style`, {
    params,
  });
//ai风格化提示词的修改
export const updataAiPrompt = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::prompt-style.prompt-style/${id}`, data);
//ai风格化提示词的删除
export const deleteAiPrompt = (id: string) =>
  instance.delete(`content-manager/collection-types/api::prompt-style.prompt-style/${id}`);
//ai风格化提示词的发布
export const publishAiPrompt = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::prompt-style.prompt-style/${id}/actions/publish`
  );
//ai风格化提示词的取消发布
export const unpublishAiPrompt = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::prompt-style.prompt-style/${id}/actions/unpublish`
  );
// ai风格化提示词的批量发布
export const publishAiPromptApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::prompt-style.prompt-style/${id}/actions/publish`
  );
//ai风格化提示词的批量取消发布
export const unpublishAiPromptApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::prompt-style.prompt-style/${id}/actions/unpublish`
  );
//ai风格化提示词的批量删除
export const bulkDeleteAiPromptApi = (ids: number[]) => {
  instance.post(
    `/content-manager/collection-types/api::prompt-style.prompt-style/actions/bulkDelete`,
    { ids }
  );
};
export const instanceaApi = instance;

// 商品模版的新增模版
export const createdTemplate = (data: any) =>
  instance.post('/content-manager/collection-types/api::pod-templ.pod-templ', data);
// 商品模版的修改模版
export const updataTemplate = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::pod-templ.pod-templ/${id}`, data);
//商品修改模版获取模版
export const getProTemplateApi = (params: any) =>
  instance.get(`/content-manager/collection-types/api::pod-templ.pod-templ`, {
    params,
  });
export const getProTemplateFoxApi = (params: any) =>
  instance.get(`/admin-extension/custom-data/api::pod-templ.pod-templ`, {
    params,
  });
//商品模版的删除模版
export const deleteProductTemplate = (id: string) =>
  instance.delete(`content-manager/collection-types/api::pod-templ.pod-templ/${id}`);
//商品模版的发布模版
export const publishProductTemplate = (id: string) =>
  instance.post(`/content-manager/collection-types/api::pod-templ.pod-templ/${id}/actions/publish`);
//商品模版的取消发布模版
export const unpublishProductTemplate = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::pod-templ.pod-templ/${id}/actions/unpublish`
  );
// 商品模版的批量发布
export const publishTemplateApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::pod-templ.pod-templ/${id}/actions/publish`);
//商品模版的取消批量发布
export const unpublishTemplateApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::pod-templ.pod-templ/${id}/actions/unpublish`
  );

// 新增模板
export const createdTempl = (data: any) =>
  instance.post('/content-manager/collection-types/api::templ.templ', data);

// 更新模板
export const updataTempl = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::templ.templ/${id}`, data);
//商品分类管理
//获取商品分类
export const getCommodityTypeApi = (params: any) =>
  instance.get(`/content-manager/collection-types/api::pod-pro-type.pod-pro-type`, {
    params,
  });

// 手机壳单面多面属性
export const getProTypeApi = (params: any) =>
  instance.get(`/content-manager/collection-types/api::pro-type.pro-type`, {
    params,
  });

// 新增商品分类
export const createCommodityTypeApi = (data: any) =>
  instance.post(`/content-manager/collection-types/api::pod-pro-type.pod-pro-type`, data);

// 新增商品类型
export const createProTypeApi = (data: any) =>
  instance.post(`/content-manager/collection-types/api::pro-type.pro-type`, data);
// 发布商品分类
export const publishCommodityTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::pod-pro-type.pod-pro-type/${id}/actions/publish`
  );
// 取消发布商品分类
export const unpublishCommodityTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::pod-pro-type.pod-pro-type/${id}/actions/unpublish`
  );

// 发布商品类型
export const publishProTypeApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::pro-type.pro-type/${id}/actions/publish`);
// 取消发布商品类型
export const unpublishProTypeApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::pro-type.pro-type/${id}/actions/unpublish`);

// 删除商品分类
export const deleteCommodityTypeApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::pod-pro-type.pod-pro-type/${id}`);

// 删除商品类型
export const deleteProTypeApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::pro-type.pro-type/${id}`);

// 编辑商品分类
export const updateCommodityTypeApi = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::pod-pro-type.pod-pro-type/${id}`, data);

// 编辑商品类型
export const updateProTypeApi = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::pro-type.pro-type/${id}`, data);

// 添加图片信息
export const addProImgLogApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::pod-img.pod-img`, data);

export const getProImgListsApi = (data: any) =>
  instance.get(`content-manager/collection-types/api::pod-img.pod-img`, {
    params: data,
  });

// 获取商品列表
export const getPodProListApi = (params: any) =>
  instance.get(`/content-manager/collection-types/api::pod-pro.pod-pro`, {
    params: {
      pageSize: 10,
      ...params,
    },
  });

// 获取商品详情
export const getPodProInfoApi = (id: string | number) =>
  instance.get(`/content-manager/collection-types/api::pod-pro.pod-pro/${id}`, {
    params: {
      populate: {
        // skus: {
        //   fields: ['id', 'code', 'name', 'price', 'weight', 'unit'],
        //   populate: {
        //     sku_attribute_values: {
        //       populate: {
        //         attribute: ['name_cn', 'name_en', 'name_es', 'type_cn', 'type_en', 'type_es'],
        //         attribute_value: ['name_cn', 'name_en', 'name_es'],
        //       },
        //     },
        //   },
        // },
        pod_pro_type: {
          fields: ['id', 'name'],
        },
        pro_type: {
          fields: ['id', 'name'],
        },
      },
    },
  });

// 新增商品
export const createPodProApi = (data: any) =>
  instance.post(`/content-manager/collection-types/api::pod-pro.pod-pro`, data);

// 编辑商品
export const updataPodProApi = (id: string | number, data: any) =>
  instance.put(`/content-manager/collection-types/api::pod-pro.pod-pro/${id}`, data);

// 发布商品
export const publishPodProApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::pod-pro.pod-pro/${id}/actions/publish`);

// 取消发布商品
export const unpublishPodProApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::pod-pro.pod-pro/${id}/actions/unpublish`);

// 删除商品
export const deletePodProApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::pod-pro.pod-pro/${id}`);

// 编辑商品
export const updatePodProApi = (id: string, data: any) =>
  instance.put(`/content-manager/collection-types/api::pod-pro.pod-pro/${id}`, data);

// 批量删除
export const batchDeletePodProApi = (ids: string[]) =>
  instance.post('/content-manager/collection-types/api::pod-pro.pod-pro/actions/bulkDelete', {
    ids,
  });

// 批量发布
export const batchPublishPodProApi = (ids: string[]) =>
  instance.post('/content-manager/collection-types/api::pod-pro.pod-pro/actions/bulkPublish', {
    ids,
  });

// 批量取消发布
export const batchUnpublishPodProApi = (ids: string[]) =>
  instance.post('/content-manager/collection-types/api::pod-pro.pod-pro/actions/bulkUnpublish', {
    ids,
  });

export const uploadApi = (data: FormData) =>
  instance.post('/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// 上传图片
export const uploadImg = (data: any) => instance.post('/upload', data);

// 更新图片
export const deleteImg = (id: string) => instance.delete('/upload/files/' + id);

// 获取详情
export const getTempl = (id: string) =>
  instance.get(`/content-manager/collection-types/api::templ.templ/${id}`);

// 获取TypeId
export const getTemplTypeId = (id: string) =>
  instance.get(`/content-manager/relations/api::templ.templ/${id}/templ_type?pageSize=5&page=1`);

// 管理员组件
export const adminComponentsUrlApi = (data: any) =>
  instance.post('/content-manager/collection-types/api::font-style.font-style', data);

// 获取管理员组件列表
export const getAdminComponentsListApi = (params: any) => {
  instance.get('/content-manager/collection-types/api::font-style.font-style', {
    params: {
      pageSize: 100,
      ...params,
    },
  });
};
// 根据类型获取管理员组件列表
export const getAdminComponentsListByTypeIdApi = (TypeId: any) =>
  instance
    .get(`/content-manager/collection-types/api::font-style.font-style?page=1&pageSize=100`)
    .then((res) => {
      return res.data.results.filter(
        (item: any) => item.font_style_type && item.font_style_type.id === TypeId
      );
    });

// 获取字体特效列表
export const getAdminFontborderListApi = (params: any) =>
  instance.get('/content-manager/collection-types/api::fontborder.fontborder', {
    params,
  });

// 更新管理员组件
export const updataAdminComponents = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::font-style.font-style/${id}`, data);

// 更新字体特效
export const updataFontborder = (id: any, data: any) =>
  instance.put(`/content-manager/collection-types/api::fontborder.fontborder/${id}`, data);

// 管理员字体特效
export const adminfontborderUrlApi = (data: any) =>
  instance.post('/content-manager/collection-types/api::fontborder.fontborder', data);

// 管理员字体
export const adminfontUrlApi = (data: any) =>
  instance.post('/content-manager/collection-types/api::font.font', data);

// 发布模板
export const publishTemplApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::templ.templ/${id}/actions/publish`);

// 获取字体样式类型
export const getFontStyleTypeApi = (params: any) =>
  instance.get('/content-manager/collection-types/api::font-style-type.font-style-type', {
    params: {
      pageSize: 100,
      ...params,
    },
  });

// 获取模板类型
export const getTemplTypeApi = (params: any) =>
  instance.get('/content-manager/collection-types/api::templ-type.templ-type', {
    params: {
      pageSize: 100,
      ...params,
    },
  });

// 添加素材
export const addMaterial = (data: any) =>
  instance.post(`/content-manager/collection-types/api::material.material`, data);

// 发布素材
export const publishMaterialApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::material.material/${id}/actions/publish`);
//取消发布素材
export const unpublishMaterialApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::material.material/${id}/actions/unpublish`);
//获取素材
export const getMaterialApi = (params: any) =>
  instance.get(`/content-manager/collection-types/api::material.material`, {
    params,
  });
//更新素材
export const saveMaterialApi = (id: string, data: any) =>
  instance.put(`/content-manager/collection-types/api::material.material/${id}`, data);
//删除素材
export const deleteMaterialApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::material.material/${id}`);
// 获取权限设置
export const setPromissionSettingApi = (id: string, data: any) =>
  instance.put(`/users-permissions/roles/${id}`, data);
//删除模板类型
export const deleteTemplTypeApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::templ-type.templ-type/${id}`);

//发布模板类型
export const publishTemplTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::templ-type.templ-type/${id}/actions/publish`
  );
//取消发布模板类型
export const unpublishTemplTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::templ-type.templ-type/${id}/actions/unpublish`
  );
//创建模板类型
export const createTemplTypeApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::templ-type.templ-type`, data);

//编辑保存模板类型
export const putTemplTypeApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::templ-type.templ-type/${id}`, data);

//获取素材类型
export const getMaterialTypeApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::material-type.material-type`, {
    params: {
      pageSize: 100,
      ...params,
    },
  });
//添加素材类型
export const createMaterialTypeApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::material-type.material-type`, data);
//更新素材类型
export const putMaterialTypeApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::material-type.material-type/${id}`, data);
//删除素材类型
export const deleteMaterialTypeApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::material-type.material-type/${id}`);
//发布素材类型
export const publishMaterialTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::material-type.material-type/${id}/actions/publish`
  );
//取消发布素材类型
export const unpublishMaterialTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::material-type.material-type/${id}/actions/unpublish`
  );
// 获取字体样式分类
export const getFontStyleTypeListApi = (params: any) =>
  instance.get('content-manager/collection-types/api::font-style-type.font-style-type', {
    params: {
      pageSize: 100,
      ...params,
    },
  });
//添加字体样式分类
export const createFontStyleTypeApi = (data: any) =>
  instance.post('content-manager/collection-types/api::font-style-type.font-style-type', data);
//更新字体样式分类
export const putFontStyleTypeApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::font-style-type.font-style-type/${id}`, data);
//删除字体样式分类
export const deleteFontStyleTypeApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::font-style-type.font-style-type/${id}`);
//发布字体样式分类
export const publishFontStyleTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::font-style-type.font-style-type/${id}/actions/publish`
  );
//取消发布字体样式分类
export const unpublishFontStyleTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::font-style-type.font-style-type/${id}/actions/unpublish`
  );
//获取画布大小
export const getCanvasSizeApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::size.size`, {
    params: {
      pageSize: 100,
      ...params,
    },
  });
//删除画布大小
export const deleteCanvasSizeApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::size.size/${id}`);
//更新画布大小
export const putCanvasSizeApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::size.size/${id}`, data);
//添加画布大小
export const createCanvasSizeApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::size.size`, data);
//发布画布大小
export const publishCanvasSizeApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::size.size/${id}/actions/publish`);
//取消发布画布大小
export const unpublishCanvasSizeApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::size.size/${id}/actions/unpublish`);
//获取banner
export const getBannerApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::banner.banner`, {
    params,
  });
//删除banner
export const deleteBannerApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::banner.banner/${id}`);
//添加banner
export const createBannerApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::banner.banner`, data);
//更新banner
export const putBannerApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::banner.banner/${id}`, data);
//发布banner
export const publishBannerApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::banner.banner/${id}/actions/publish`);
//取消发布banner
export const unpublishBannerApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::banner.banner/${id}/actions/unpublish`);
//获取通知
export const getNoticeApi = (params: any) =>
  instance.get(`content-manager/single-types/api::notice.notice/`, {
    params,
  });
//添加notice
export const createNoticeApi = (data: any) =>
  instance.post(`content-manager/single-types/api::notice.notice/`, data);
//更新notice
export const putNoticeApi = (id: string, data: any) =>
  instance.put(`content-manager/single-types/api::notice.notice/${id}`, data);
//发布notice
export const publishNoticeApi = () =>
  instance.post(`content-manager/single-types/api::notice.notice/actions/publish`);
//取消发布notice
export const unpublishNoticeApi = () =>
  instance.post(`content-manager/single-types/api::notice.notice/actions/unpublish`);
//获取logo
export const getLogoApi = (params: any) =>
  instance.get(`content-manager/single-types/api::web-site.web-site/`, {
    params,
  });
//更新logo
export const putLogoApi = (id: string, data: any) =>
  instance.put(`content-manager/single-types/api::web-site.web-site/?locale=en`, data);
//添加logo
export const createLogoApi = (data: any) =>
  instance.post(`content-manager/single-types/api::web-site.web-site/`, data);
//发布logo
export const publishLogoApi = () =>
  instance.post(`content-manager/single-types/api::web-site.web-site/actions/publish?locale=en`);
//取消发布logo
export const unpublishLogoApi = () =>
  instance.post(`content-manager/single-types/api::web-site.web-site/actions/unpublish?locale=en`);
//获取模板
export const getTemplateApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::templ.templ`, {
    params,
  });
//删除模板
export const deleteTemplateApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::templ.templ/${id}`);
//取消发布模板
export const unpublishTemplApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::templ.templ/${id}/actions/unpublish`);
//获取字体样式
export const getFontStyleApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::font-style.font-style`, {
    params,
  });
//添加字体样式
export const createFontStyleApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::font-style.font-style`, data);
// 发布字体样式
export const publishFontStyleApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::font-style.font-style/${id}/actions/publish`
  );
//取消发布字体样式
export const unpublishFontStyleApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::font-style.font-style/${id}/actions/unpublish`
  );
//更新字体样式
export const putFontStyleApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::font-style.font-style/${id}`, data);
//删除字体样式
export const deleteFontStyleApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::font-style.font-style/${id}`);
//获取字体
export const getFontApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::font.font`, {
    params,
  });

//添加字体
export const createFontApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::font.font`, data);
// 发布字体
export const publishFontApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::font.font/${id}/actions/publish`);
//取消发布字体
export const unpublishFontApi = (id: string) =>
  instance.post(`/content-manager/collection-types/api::font.font/${id}/actions/unpublish`);
//更新字体
export const putFontApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::font.font/${id}`, data);
//删除字体
export const deleteFontApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::font.font/${id}`);
//获取字体特效
export const getFontBorderApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::fontborder.fontborder`, {
    params,
  });
//添加字体特效
export const createFontBorderApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::fontborder.fontborder`, data);
//发布字体特效
export const publishFontBorderApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::fontborder.fontborder/${id}/actions/publish`
  );
//取消发布字体特效
export const unpublishFontBorderApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::fontborder.fontborder/${id}/actions/unpublish`
  );
//删除字体特效
export const deleteFontBorderApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::fontborder.fontborder/${id}`);
//更新字体特效
export const putFontBorderApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::fontborder.fontborder/${id}`, data);
//获取用户字体
export const getUserFontApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::userfont.userfont`, {
    params,
  });
//添加用户字体
export const createUserFontApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::userfont.userfont`, data);
//删除用户字体
export const deleteUserFontApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::userfont.userfont/${id}`);
//批量删除用户字体
export const batchDeleteUserFontApi = (ids: number[]) =>
  instance.post('/content-manager/collection-types/api::userfont.userfont/actions/bulkDelete', {
    ids,
  });
//更新用户字体
export const putUserFontApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::userfont.userfont/${id}`, data);
//发布用户字体
export const publishUserFontApi = (id: string) =>
  instance.post(`content-manager/collection-types/api::userfont.userfont/${id}/actions/publish`);
//取消发布用户字体
export const unpublishUserFontApi = (id: string) =>
  instance.post(`content-manager/collection-types/api::userfont.userfont/${id}/actions/unpublish`);
//获取用户模板
export const getUserTemplApi = (params: any) =>
  instance.get(`/admin-extension/custom-data/api::user-templ.user-templ`, {
    params,
  });
//添加用户模板
export const createUserTemplApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::user-templ.user-templ`, data);
//删除用户模板
export const deleteUserTemplApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::user-templ.user-templ/${id}`);
//批量删除用户模板
export const batchDeleteUserTemplApi = (ids: number[]) =>
  instance.post('/content-manager/collection-types/api::user-templ.user-templ/actions/bulkDelete', {
    ids,
  });
//更新用户模板
export const putUserTemplApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::user-templ.user-templ/${id}`, data);
//发布用户模板
export const publishUserTemplApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::user-templ.user-templ/${id}/actions/publish`
  );
//取消发布用户模板
export const unpublishUserTemplApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::user-templ.user-templ/${id}/actions/unpublish`
  );
//获取用户素材
export const getUserMaterialApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::user-material.user-material`, {
    params,
  });
//添加用户素材
export const createUserMaterialApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::user-material.user-material`, data);
//删除用户素材
export const deleteUserMaterialApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::user-material.user-material/${id}`);
//批量删除用户素材
export const batchDeleteUserMaterialApi = (ids: number[]) =>
  instance.post(
    '/content-manager/collection-types/api::user-material.user-material/actions/bulkDelete',
    { ids }
  );
//更新用户素材
export const putUserMaterialApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::user-material.user-material/${id}`, data);
//发布用户素材
export const publishUserMaterialApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::user-material.user-material/${id}/actions/publish`
  );
//取消用户素材发布
export const unpublishUserMaterialApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::user-material.user-material/${id}/actions/unpublish`
  );
//获取用户列表
export const getUsersApi = (params: any) =>
  instance.get(`/admin-extension/custom-data/plugin::users-permissions.user`, {
    params,
  });
//获取用户组合
export const getUserGroupApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::user-component.user-component`, {
    params,
  });
//添加用户组合
export const createUserGroupApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::user-component.user-component`, data);
//删除用户组合
export const deleteUserGroupApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::user-component.user-component/${id}`);
//批量删除用户组合
export const batchDeleteUserGroupApi = (ids: number[]) =>
  instance.post(
    '/content-manager/collection-types/api::user-component.user-component/actions/bulkDelete',
    { ids }
  );
//更新用户组合
export const putUserGroupApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::user-component.user-component/${id}`, data);
//发布用户组合
export const publishUserGroupApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::user-component.user-component/${id}/actions/publish`
  );
//取消发布用户组合
export const unpublishUserGroupApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::user-component.user-component/${id}/actions/unpublish`
  );
//删除媒体库文件
export const deleteMediaApi = (data: any) => instance.post(`upload/actions/bulk-delete`, data);

// 获取服务协议
export const getTermsApi = () =>
  instance.get(`/content-manager/single-types/api::user-agreement.user-agreement/`);
//更新服务协议
export const putTermsApi = (data: any) =>
  instance.put(`/content-manager/single-types/api::user-agreement.user-agreement/`, data);
//取消发布服务协议
export const unpublishTermsApi = () =>
  instance.post(
    `/content-manager/single-types/api::user-agreement.user-agreement/actions/unpublish`
  );
//发布服务协议
export const publishTermsApi = () =>
  instance.post(`/content-manager/single-types/api::user-agreement.user-agreement/actions/publish`);
//获取背景类型
export const getBackgroundTypeApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::background-type.background-type`, {
    params,
  });
//添加背景类型
export const createBackgroundTypeApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::background-type.background-type`, data);
//更新背景类型
export const putBackgroundTypeApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::background-type.background-type/${id}`, data);
//删除背景类型
export const deleteBackgroundTypeApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::background-type.background-type/${id}`);
//发布背景类型
export const publishBackgroundTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::background-type.background-type/${id}/actions/publish`
  );
//取消发布背景类型
export const unpublishBackgroundTypeApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::background-type.background-type/${id}/actions/unpublish`
  );
//获取背景
export const getBackgroundApi = (params: any) =>
  instance.get(`content-manager/collection-types/api::background.background`, {
    params,
  });
//添加背景
export const createBackgroundApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::background.background`, data);
//更新背景
export const putBackgroundApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::background.background/${id}`, data);
//删除背景
export const deleteBackgroundApi = (id: string) =>
  instance.delete(`content-manager/collection-types/api::background.background/${id}`);
//发布背景
export const publishBackgroundApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::background.background/${id}/actions/publish`
  );
//取消发布背景
export const unpublishBackgroundApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::background.background/${id}/actions/unpublish`
  );

// VIP 配置相关接口
// 创建
export const createOrUpdateVipConfigApi = (data: any) =>
  instance.post('/content-manager/collection-types/api::vip-config.vip-config', data);

// 获取 VIP 配置列表
export const getVipConfigsApi = (params: any) =>
  instance
    .get('/content-manager/collection-types/api::vip-config.vip-config', { params })
    .then((res) => res.data);

// 获取单个 VIP 配置
export const getVipConfigByIdApi = (id: string) =>
  instance.get(`/content-manager/collection-types/api::vip-config.vip-config/${id}`);

// 删除 VIP 配置
export const deleteVipConfigApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::vip-config.vip-config/${id}`);
//编辑VIP 配置
export const updateVipConfigApi = (id: string, data: any) =>
  instance.put(`/content-manager/collection-types/api::vip-config.vip-config/${id}`, data);
//获取vip列表
export const getVipListApi = (params: any) =>
  instance
    .get(`/content-manager/collection-types/api::vip-user.vip-user`, { params })
    .then((res) => res.data);

// 删除vip用户
export const deleteVipUserApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::vip-user.vip-user/${id}`);

//批量删除 VIP 配置
export const batchDeleteVipConfigApi = (ids: number[]) => {
  instance.post('/content-manager/collection-types/api::vip-config.vip-config/actions/bulkDelete', {
    ids,
  });
};
//取消发布VIP 配置
export const unpublishVipConfigApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::vip-config.vip-config/${id}/actions/unpublish`
  );
//发布VIP 配置
export const publishVipConfigApi = (id: string) =>
  instance.post(
    `/content-manager/collection-types/api::vip-config.vip-config/${id}/actions/publish`
  );

export const addProImgApi = (data: any) =>
  instance.post(`/content-manager/collection-types/api::pod-img.pod-img`, data);

export const delProImgLogApi = (data: any) =>
  instance.post(`/content-manager/collection-types/api::pod-img.pod-img/actions/bulkDelete`, data);
export const podOrderListApi = {
  // 获取订单列表
  find: (params: any) =>
    instance.get(`/content-manager/collection-types/api::user-pro-order.user-pro-order`, {
      params,
    }),

  del: (id: string) =>
    instance.delete(`/content-manager/collection-types/api::user-pro-order.user-pro-order/${id}`),
  batchDel: (ids: number[]) =>
    instance.post(
      '/content-manager/collection-types/api::user-pro-order.user-pro-order/actions/bulkDelete',
      {
        ids,
      }
    ),
  update: (id: string, data: any) =>
    instance.put(
      `/content-manager/collection-types/api::user-pro-order.user-pro-order/${id}`,
      data
    ),
  get: (id: string) =>
    instance.get(
      `/content-manager/relations/api::user-pro-order.user-pro-order/${id}/user_pro_order_items`
    ),
};
// 订单商品详情
export const podOrderItemListApi = (params: any) => {
  return instance.get(
    `/content-manager/collection-types/api::user-pro-order-item.user-pro-order-item`,
    {
      params,
    }
  );
};

// 店铺管理
export const shopManageApi = createapi('api::user-shop.user-shop');
// 店铺订单
export const shopLogoManageApi = createapi('api::design-logo-order.design-logo-order');
// 用户管理
export const userManageApi = createapi('plugin::users-permissions.user');
// 用户金币管理
export const userCoinManageApi = createapi('api::user-coin.user-coin');
// 商品分类
export const proTypeManageApi = createapi('api::pod-pro-type.pod-pro-type');
// 商品管理
export const proManageApi = createapi('api::pod-pro.pod-pro');
// 店铺商品授权管理
export const shopProManageApi = createapi('api::user-shop-pro-type.user-shop-pro-type');
// 店铺订单管理
export const shopOrderManageApi = createapi('api::shop-order.shop-order');
// 获取sku属性表
export const attributesManageApi = (params: any) =>
  instance.get('/content-manager/collection-types/api::attribute.attribute', {
    params: {
      pageSize: 100,
      ...params,
    },
  });
// 删除sku属性表
export const deleteAttributesApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::attribute.attribute/${id}`);
//添加SKU属性
export const createAttributeApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::attribute.attribute`, data);
export const putAttributeApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::attribute.attribute/${id}`, data);
// 获取sku属性数值表
export const attributesValueManageApi = (params: any) =>
  instance.get('/content-manager/collection-types/api::attribute-value.attribute-value', {
    params: {
      pageSize: 100,
      ...params,
    },
  });
//添加SKU属性值
export const createAttributeValueApi = (data: any) =>
  instance.post(`content-manager/collection-types/api::attribute-value.attribute-value`, data);
//删除SKU属性值
export const deleteAttributesValueApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::attribute-value.attribute-value/${id}`);
//修改
export const putAttributeValueApi = (id: string, data: any) =>
  instance.put(`content-manager/collection-types/api::attribute-value.attribute-value/${id}`, data);

export const getattributesManageApi = (params: any) =>
  instance.get('/content-manager/collection-types/api::attribute.attribute', {
    params: {
      // 'pagination[pageSize]': -1,
      ...params,
    },
  });
//新增sku
export const createSkuApi = (data: any) =>
  instance.post(`/content-manager/collection-types/api::sku.sku`, data);
//修改sku
export const putSkuApi = (id: string, data: any, clearOrderImages = false) =>
  instance.put(`/content-manager/collection-types/api::sku.sku/${id}`, data, {
    params: { clearOrderImages },
  });
//删除sku
export const deleteSkuApi = (id: string) =>
  instance.delete(`/content-manager/collection-types/api::sku.sku/${id}`);
// 获取sku详情
export const getSKUInfoApi = (id: string | number) =>
  instance.get(`/content-manager/collection-types/api::sku.sku/${id}`, {
    params: {
      populate: {
        proImages: '*',
        img: '*',
        sku_attribute_values: '*',
      },
    },
  });
//新增sku-attribute-value
export const createSkuattributevaluesApi = (data: any) =>
  instance.post(
    `/content-manager/collection-types/api::sku-attribute-value.sku-attribute-value`,
    data
  );
//修改sku-attribute-value
export const updataSkuattributevaluesApi = (id: string, data: any) =>
  instance.put(
    `/content-manager/collection-types/api::sku-attribute-value.sku-attribute-value/${id}`,
    data
  );
// 获取指定 sku 下的属性值列表
export const getSkuattributevaluesApi = (skuId: string | number) =>
  instance.get(`/content-manager/collection-types/api::sku-attribute-value.sku-attribute-value`, {
    params: {
      filters: {
        sku: skuId, // 筛选出属于该 sku 的记录
      },
      populate: '*', // 如果要把 attribute 和 attribute_value 一起取出来
    },
  });
// 删除 sku-attribute-value
export const deleteSkuattributevaluesApi = (id: string | number) =>
  instance.delete(
    `/content-manager/collection-types/api::sku-attribute-value.sku-attribute-value/${id}`
  );
//home-banner
export const shopHomeBannerApi = createapi('api::homebanner.homebanner');
//获取所有的的商品
export const getAllPodProListApi = (params = {}) =>
  instance.get(`/content-manager/collection-types/api::pod-pro.pod-pro`, {
    params,
  });

export const copyshopper = (data: any) => {
  return instance.post(`/admin-extension/custom-data/pod-pro/copy`, {
    ids: data,
  });
};
export const getSkusLists = (id: number | string, params: any) => {
  return instance.get(`/admin-extension/custom-data/pod-pro/getSkusList/${id}`);
};
